export default [{
  name: 'User',
  prop: 'user_id',
  type: 'autocomplete',
  references: 'admin/users',
  referenceProp: 'fullname',
  displayProp: 'name',
  disabled: true
}, {
  name: 'Matched',
  prop: 'matched',
  type: 'checkbox',
  disabled: true
}]
